(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brume-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__brumeCta) return;
    window.__brumeCta = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-brume-select]');
      if (!a) return;
      var target = document.getElementById('brume-acheter');
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo({ top: y, behavior: 'smooth' });
      var id = a.getAttribute('data-brume-select');
      if (id) {
        var card = document.querySelector('.brume-oc[data-variant-id="' + id + '"]');
        if (card && !card.classList.contains('is-active')) setTimeout(function () { card.click(); }, 350);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brume-diagnostic"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var ICO={
      peau:'<path d="M12 3c3 4 6 7.5 6 11a6 6 0 0 1-12 0c0-3.5 3-7 6-11z"/>',
      souci:'<circle cx="12" cy="12" r="8"/><circle cx="9" cy="10" r="1.3"/><circle cx="14.5" cy="13.5" r="1.8"/>',
      sensi:'<path d="M12 21s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 11c0 5.5-7 10-7 10z"/>',
      sol:'<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>',
      enc:'<circle cx="12" cy="7" r="3"/><path d="M8 21v-5a4 4 0 0 1 8 0v5"/>'
    };
    var Q=[
      {k:'peau',t:'Comment est ta peau en fin de journée ?',o:['Elle tiraille, plutôt sèche','Confortable, plutôt normale','Brillante sur la zone T, mixte','Brillante partout, plutôt grasse']},
      {k:'souci',t:'Qu\u2019est-ce qui te préoccupe le plus ?',o:['Les taches brunes','Les ridules','Un teint terne ou irrégulier','Les marques laissées par les boutons']},
      {k:'sensi',t:'Ta peau réagit-elle facilement ?',o:['Rarement','De temps en temps','Souvent : rougeurs, picotements']},
      {k:'sol',t:'Tu mets de la crème solaire sur le visage ?',o:['Tous les jours','Seulement à la plage','Presque jamais']},
      {k:'enc',t:'Es-tu enceinte ou allaites-tu en ce moment ?',o:['Non','Oui']}
    ];
    var SK=['Peau sèche','Peau normale','Peau mixte','Peau grasse'],CO=['Taches brunes','Ridules','Teint terne','Marques de boutons'];
    var FR=['Tu peux l\u2019utiliser tous les soirs dès le début.','Commence 3 soirs par semaine, puis passe à tous les soirs si ta peau le tolère bien.','Commence 2 soirs par semaine pendant 2 semaines, puis augmente doucement si ta peau ne réagit pas.'];
    var MA=['Une crème hydratante riche, puis ta crème solaire.','Ta crème habituelle, puis ta crème solaire.','Une crème légère ou un gel, puis ta crème solaire.','Un gel hydratant léger, puis une solaire au fini mat.'];
    var TI=['Les taches demandent de la régularité : c\u2019est tout l\u2019intérêt de la cure de 3 mois.','Pense au cou et au décolleté : ils marquent aussi vite que le visage.','Un nettoyage doux le soir aide le masque à mieux agir sur l\u2019éclat.','Évite de toucher tes boutons : chaque inflammation peut laisser une nouvelle marque.'];
    var SU=['Tu mets ta solaire tous les jours : parfait, c\u2019est elle qui protège tes résultats.','Ici, le soleil tape toute l\u2019année, pas seulement à la plage. Sans solaire chaque matin, les taches reviennent : c\u2019est le geste le plus important de ta routine.','Sans crème solaire chaque matin, les taches reviennent, même avec le meilleur soin de nuit. C\u2019est le premier geste à ajouter.'];
    function init(root){
      if(root._b)return;root._b=true;
      var imgs={};
      var j=root.parentNode.querySelector('[data-brume-diag-imgs]');
      try{imgs=JSON.parse(j.textContent)}catch(e){}
      var step=0,a={};
      function show(name){root.querySelectorAll('.brume-dg__screen').forEach(function(s){s.classList.toggle('is-on',s.getAttribute('data-step')===name)});var y=root.getBoundingClientRect().top+window.scrollY-90;window.scrollTo({top:y,behavior:'smooth'});}
      function renderQ(){
        var q=Q[step-1];
        root.querySelector('[data-count]').textContent='Question '+step+' sur 5';
        root.querySelector('[data-bar]').style.width=(step/5*100)+'%';
        root.querySelector('[data-qtitle]').textContent=q.t;
        var box=root.querySelector('[data-opts]');box.innerHTML='';
        q.o.forEach(function(l,i){
          var b=document.createElement('button');b.type='button';b.className='brume-dg__opt'+(a[q.k]===i?' is-picked':'');
          var src=(imgs[q.k]||[])[i];
          if(src){var im=document.createElement('img');im.className='brume-dg__img';im.src=src;im.alt='';im.loading='lazy';b.appendChild(im);}
          else{var ic=document.createElement('span');ic.className='brume-dg__ico';ic.innerHTML='<svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+ICO[q.k]+'</svg>';b.appendChild(ic);}
          var t=document.createElement('span');t.className='brume-dg__lbl';t.textContent=l;b.appendChild(t);
          b.addEventListener('click',function(){a[q.k]=i;next();});box.appendChild(b);
        });
        show('q');
      }
      function result(){
        if(a.enc===1){show('pregnant');return;}
        root.querySelector('[data-chips]').innerHTML='<span>'+SK[a.peau]+'</span><span>'+CO[a.souci]+'</span>';
        root.querySelector('[data-r-soir]').textContent='Masque de Nuit Collagène en dernière étape, sur peau propre, puis 15 minutes de séchage. '+FR[a.sensi];
        root.querySelector('[data-r-matin]').textContent=MA[a.peau];
        root.querySelector('[data-r-conseil]').textContent=TI[a.souci];
        root.querySelector('[data-r-sun]').textContent=SU[a.sol];
        show('result');
      }
      function next(){step++;if(step>5)result();else renderQ();}
      root.addEventListener('click',function(e){
        if(e.target.closest('[data-go]')){step=1;renderQ();}
        else if(e.target.closest('[data-back]')){if(step<=1){show('intro');step=0;}else{step--;renderQ();}}
        else if(e.target.closest('[data-restart]')){a={};step=0;show('intro');}
      });
    }
    function run(){document.querySelectorAll('[data-brume-diag]').forEach(init);}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
    document.addEventListener('shopify:section:load',run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brume-preuves"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function run(){document.querySelectorAll('[data-brume-cmp]').forEach(function(f){var r=f.parentNode.querySelector('[data-brume-range]'),a=f.querySelector('[data-brume-after]');if(!r||!a||r._b)return;r._b=1;var set=function(){a.style.clipPath='inset(0 0 0 '+r.value+'%)';};r.addEventListener('input',set);set();});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
    document.addEventListener('shopify:section:load',run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
